(function () {
  var GEO_NEUTRAL_COUNTRIES = { IN: true, PK: true };
  var PROMO_TEXT_RE = /\b(sale|soldes|rebajas|saldo|saldi|ausverkauf|best\s*seller|bestseller|use\s+code|code\s+promo|promo\s+code|coupon|discount|reduction|réduction|descuento|rabatt|off|limited\s*time|hurry|last\s*chance|almost\s*sold\s*out|selling\s*fast|only\s+\d+\s+left|summer\s+sale)\b|(\d{1,2}\s*%\s*(off|de réduction|reduction|descuento|rabatt))/i;
  var SHORT_TEXT_LIMIT = 140;

  function normalizeCountry(value) {
    return String(value || '').trim().toUpperCase();
  }

  function countryFromPayload(payload) {
    if (!payload || typeof payload !== 'object') return '';

    var candidates = [
      payload.country,
      payload.country_code,
      payload.countryCode,
      payload.detected_country,
      payload.detectedCountry,
      payload.detected_values && payload.detected_values.country,
      payload.detectedValues && payload.detectedValues.country,
      payload.suggestions && payload.suggestions.country,
      payload.localization && payload.localization.country
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      var country = candidates[i];
      if (!country) continue;
      if (typeof country === 'string') return normalizeCountry(country);
      if (typeof country === 'object') {
        var code = country.iso_code || country.isoCode || country.country_code || country.countryCode || country.handle || country.code;
        if (code) return normalizeCountry(code);
      }
    }

    return '';
  }

  function enableGeoNeutral() {
    document.documentElement.classList.add('mm-geo-neutral');
    document.documentElement.classList.remove('mm-geo-pending');
    scrubPromoText();
  }

  function disableGeoNeutral() {
    document.documentElement.classList.remove('mm-geo-neutral');
    document.documentElement.classList.remove('mm-geo-pending');
  }

  function shouldHideElement(element) {
    if (!element || element.children.length > 3) return false;

    var text = (element.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || text.length > SHORT_TEXT_LIMIT) return false;

    return PROMO_TEXT_RE.test(text);
  }

  function hidePromoContainer(element) {
    var container = element.closest('.announcement-bar-section, .countdown-wrapper, cart-discount-block, .cart-discount, .rich-text, .image-with-text, .multicolumn, .product__info-container > *');
    if (container && container !== document.body && container !== document.documentElement) {
      container.setAttribute('data-mm-promo-section-hidden', 'true');
    } else {
      element.setAttribute('data-mm-promo-hidden', 'true');
    }
  }

  function scrubPromoText(root) {
    if (!document.documentElement.classList.contains('mm-geo-neutral')) return;

    var scope = root && root.querySelectorAll ? root : document;
    var selectors = [
      '.announcement-bar *',
      '.badge',
      '.price__badge-sale',
      '.product__inventory',
      '.inventory-status',
      '.countdown-wrapper *',
      '.cart-discount *',
      '.rich-text__text',
      '.product__text',
      '.caption-with-letter-spacing',
      'small',
      'span',
      'strong',
      'p'
    ].join(',');

    scope.querySelectorAll(selectors).forEach(function (element) {
      if (shouldHideElement(element)) {
        hidePromoContainer(element);
      }
    });
  }

  function hideWomenNavigation(root) {
    if (!document.documentElement.classList.contains('mm-geo-neutral')) return;

    var scope = root && root.querySelectorAll ? root : document;
    var selectors = [
      '.mm-women-nav',
      '.mm-gender-switch',
      'a[href*="/collections/women"]',
      '[id*="HeaderMenu-women"]',
      '[id*="HeaderMenu-Women"]',
      '[id*="Details-HeaderMenu-Women"]',
      '[id*="MegaMenu-Content-Women"]'
    ].join(',');

    scope.querySelectorAll(selectors).forEach(function (element) {
      var container = element.closest('li, header-menu, .mm-gender-switch, details, nav');
      (container || element).setAttribute('data-mm-promo-hidden', 'true');
    });
  }

  function detectFromShopifyBrowsingContext() {
    if (document.documentElement.classList.contains('mm-geo-neutral')) {
      scrubPromoText();
      hideWomenNavigation();
      return;
    }

    var country = normalizeCountry(document.documentElement.getAttribute('data-mm-country'));
    if (GEO_NEUTRAL_COUNTRIES[country]) {
      enableGeoNeutral();
      return;
    }

    fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('No browsing context');
        return response.json();
      })
      .then(function (payload) {
        var detectedCountry = countryFromPayload(payload);
        if (GEO_NEUTRAL_COUNTRIES[detectedCountry]) {
          enableGeoNeutral();
          hideWomenNavigation();
        } else {
          disableGeoNeutral();
        }
      })
      .catch(function () {
        disableGeoNeutral();
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    detectFromShopifyBrowsingContext();

    var observer = new MutationObserver(function (mutations) {
      if (!document.documentElement.classList.contains('mm-geo-neutral')) return;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            scrubPromoText(node);
            hideWomenNavigation(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
